import { Link } from "react-router-dom";

const TELEGRAM_URL = "https://t.me/Vertttess";

export default function Footer() {
  return (
    <footer className="relative bg-secondary-100 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/readdy/6606b04b1f7f2f98f392e21c6ab06083.png"
                alt="Have Received"
                className="h-10 w-auto"
              />
              <span className="font-heading text-xl text-foreground-900">
                Have Received
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              Профессиональный подбор и обучение администраторов для
              гостиничного бизнеса по всей России.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading text-lg text-foreground-900 mb-4">
              Навигация
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="#hero"
                  onClick={(e) => {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  Главная
                </a>
              </li>
              <li>
                <a href="#advantages" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Преимущества
                </a>
              </li>
              <li>
                <a href="#partners" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Партнёры
                </a>
              </li>
              <li>
                <a href="#cases" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Кейсы
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Тарифы
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <Link to="/vacancies" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Вакансии
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg text-foreground-900 mb-4">
              Контакты
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-telegram-line text-lg shrink-0" />
                <a
                  href={TELEGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary-600 transition-colors"
                >
                  Telegram
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-lg shrink-0" />
                <span>Работаем по всей России</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-time-line text-lg shrink-0" />
                <span>Ответ в течение часа</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-background-300/60 flex flex-col items-center gap-4 text-center">
          <div className="text-xs text-foreground-500 space-y-1">
            <p>ИП Максимов Сергей Валерьевич</p>
            <p>ИНН: 250209410221 | ОГРНИП: 314250227500010</p>
          </div>
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Have Received. Все права защищены.
          </p>
          <div className="flex items-center gap-4">
            <a
              href={TELEGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground-500 hover:text-primary-600 transition-colors"
            >
              <i className="ri-telegram-line text-xl" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}